import { NavLink } from "react-router-dom";
import { Home, Brain, Compass, HandHeart, ParkingSquare, ListChecks, Settings } from "lucide-react";

const items = [
  { to: "/", label: "Today", icon: Home, testid: "nav-today" },
  { to: "/brain-dump", label: "Dump", icon: Brain, testid: "nav-brain-dump" },
  { to: "/next", label: "Next", icon: Compass, testid: "nav-next" },
  { to: "/trust", label: "Trust", icon: HandHeart, testid: "nav-trust" },
  { to: "/parking-lot", label: "Parking", icon: ParkingSquare, testid: "nav-parking" },
  { to: "/tasks", label: "Tasks", icon: ListChecks, testid: "nav-tasks" },
  { to: "/settings", label: "Settings", icon: Settings, testid: "nav-settings" },
];

export const BottomNav = () => {
  return (
    <nav
      data-testid="bottom-nav"
      className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-md h-[72px] bg-zinc-900/90 backdrop-blur-xl border-t border-zinc-800 z-50 flex justify-around items-center px-1 pb-safe"
    >
      {items.map(({ to, label, icon: Icon, testid }) => (
        <NavLink
          key={to}
          to={to}
          end={to === "/"}
          data-testid={testid}
          className={({ isActive }) =>
            `flex flex-col items-center justify-center gap-1 flex-1 h-full transition-colors ${
              isActive ? "text-[#7FB0B5]" : "text-zinc-500 hover:text-zinc-300"
            }`
          }
        >
          <Icon strokeWidth={2} className="w-[22px] h-[22px]" />
          <span className="text-[10px] font-medium tracking-tight">{label}</span>
        </NavLink>
      ))}
    </nav>
  );
};
